import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import "swiper/css";
import "swiper/css/navigation";
import { Images } from "../Components/Images";
import Header from "../layout/Header";
import NewFooter from "../layout/Footer";
import { Accordion } from "react-bootstrap";
import { getAllFAQ } from "../actions/settings";

const Faq = () => {
  const [cardContent, setCardContent] = useState([
    {
      question: "1. What is a flash loan arbitrage bot?",
      answer:
        "A flash loan arbitrage bot is an automated trading program that utilizes flash loans to exploit price differences between cryptocurrency exchanges. It leverages temporary liquidity provided by flash loans to execute profitable trades within a single transaction.",
    },
    {
      question: "2. How does the flash loan arbitrage bot work?",
      answer:
        "Lorem ipsum dolor sit amet consectetur. Elit euismod ipsum tristique donec et. Tincidunt ultricies fringilla orci eu tortor in ornare. Venenatis leo imperdiet quisque varius. Pretium lorem eget vitae lobortis luctus ridiculus.",
    },
    {
      question: "3. What are flash loans?",
      answer:
        "Lorem ipsum dolor sit amet consectetur. Elit euismod ipsum tristique donec et. Tincidunt ultricies fringilla orci eu tortor in ornare. Venenatis leo imperdiet quisque varius. Pretium lorem eget vitae lobortis luctus ridiculus.",
    },
    {
      question: "4. Is flash loan arbitrage trading risky?.",
      answer:
        "Lorem ipsum dolor sit amet consectetur. Elit euismod ipsum tristique donec et. Tincidunt ultricies fringilla orci eu tortor in ornare. Venenatis leo imperdiet quisque varius. Pretium lorem eget vitae lobortis luctus ridiculus.",
    },
    {
      question:
        "5. What are the potential benefits of using a flash loan arbitrage bot?",
      answer:
        "Lorem ipsum dolor sit amet consectetur. Elit euismod ipsum tristique donec et. Tincidunt ultricies fringilla orci eu tortor in ornare. Venenatis leo imperdiet quisque varius. Pretium lorem eget vitae lobortis luctus ridiculus.",
    },
    {
      question: "1. What is a flash loan arbitrage bot?",
      answer:
        "A flash loan arbitrage bot is an automated trading program that utilizes flash loans to exploit price differences between cryptocurrency exchanges. It leverages temporary liquidity provided by flash loans to execute profitable trades within a single transaction.",
    },
    {
      question: "2. How does the flash loan arbitrage bot work?",
      answer:
        "Lorem ipsum dolor sit amet consectetur. Elit euismod ipsum tristique donec et. Tincidunt ultricies fringilla orci eu tortor in ornare. Venenatis leo imperdiet quisque varius. Pretium lorem eget vitae lobortis luctus ridiculus.",
    },
    {
      question: "3. What are flash loans?",
      answer:
        "Lorem ipsum dolor sit amet consectetur. Elit euismod ipsum tristique donec et. Tincidunt ultricies fringilla orci eu tortor in ornare. Venenatis leo imperdiet quisque varius. Pretium lorem eget vitae lobortis luctus ridiculus.",
    },
    {
      question: "4. Is flash loan arbitrage trading risky?.",
      answer:
        "Lorem ipsum dolor sit amet consectetur. Elit euismod ipsum tristique donec et. Tincidunt ultricies fringilla orci eu tortor in ornare. Venenatis leo imperdiet quisque varius. Pretium lorem eget vitae lobortis luctus ridiculus.",
    },
    {
      question:
        "5. What are the potential benefits of using a flash loan arbitrage bot?",
      answer:
        "Lorem ipsum dolor sit amet consectetur. Elit euismod ipsum tristique donec et. Tincidunt ultricies fringilla orci eu tortor in ornare. Venenatis leo imperdiet quisque varius. Pretium lorem eget vitae lobortis luctus ridiculus.",
    },
  ]);


  const getFAQData = async () => {
    let { status, message, data, count } = await getAllFAQ();
    if (status == "success") {
      setCardContent(data);
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, []);


  useEffect(() => {
    getFAQData()
  }, []);

  return (
    <>
      <Container fluid className="p-0 position-relative common_bg plan_bgVideo">
        {/* <video
          src={Images.bannerBg_vdo}
          autoPlay
          muted
          loop
          className="img-fluid video_src"
        />
        <div className="overlay_bg" />

        <img src={Images.planlftOvly} className="plans__lftBlur img-fluid" />
        <img src={Images.planrytOvly} className="plans__rightBlur img-fluid" /> */}
        <Header />
        <Container className="p-0 position-relative common_bgg w-100 h-100 custom_container z-3">
          <Container className="home__indexAligner innerpages_ui">
            <div className="plans__holder">
              <h4 className="m-0 hebrew_bold opportunity__title">FAQ</h4>
            </div>
            <div className="faq_pageCnt frequently_askQus pb-0">
              <div className="qus_ans">
                <p className="title-txt mb-0 p-0">Frequently Asked Question</p>
                <div className="card_sec ">
                  <Accordion
                    defaultActiveKey="0"
                    className="freqQus_accordion"
                    flush
                  >
                    {cardContent &&
                      cardContent?.map((item, i) => {
                        console.log(item, "cardConten1");
                        return (
                          <Accordion.Item eventKey={i} className="">
                            <Accordion.Header>
                              {item?.question}
                            </Accordion.Header>
                            <Accordion.Body>{item?.answer}</Accordion.Body>
                          </Accordion.Item>
                        );
                      })}
                  </Accordion>
                </div>
              </div>
            </div>
          </Container>
        </Container>
      </Container>
      <NewFooter />
    </>
  );
};

export default Faq;
